export * from "modules/KeyLockersDashboard/components/DeleteKeyLockerModal/hooks/useDeleteKeyLockerMutation";
